import React, { Suspense, lazy, useRef, useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useInView } from "../hooks/useInView";
import CircularSpinner from "../components/circularSpinner";

const HeroSection = lazy(() => import("../components/HeroSection"));
const TravelExperience = lazy(() => import("../components/TravelExperience"));
const AboutSection = lazy(() => import("../components/AboutSection"));
const AllInOne = lazy(() => import("../components/AllInOne"));
const BookingProcess = lazy(() => import("../components/BookingProcess"));
const BusinessPartner = lazy(() => import("../components/BusinessPartner"));
const RideWithAi = lazy(() => import("../components/RideWithAi"));
const ManagementAgents = lazy(() => import("../components/ManagementAgents"));
const PartnerSection = lazy(() => import("../components/PartnerSection"));
const AgentPartnerSection = lazy(() => import("../components/AgentPartnerSection"));
const BusinessPartnerSection = lazy(() => import("../components/BusinessPartnerSection"));
const PrimaryTaskSection = lazy(() => import("../components/PrimaryTaskSection"));
const USPSection = lazy(() => import("../components/UspSection"));

const LazyLoadSection = ({ children }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { threshold: 0.1 });
  const [showSpinner, setShowSpinner] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSpinner(false);
    }, 1000); // Show spinner for 1 second

    return () => clearTimeout(timer);
  }, []);

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 50 }}
      animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
      transition={{ duration: 0.5 }}
    >
      {showSpinner ? <CircularSpinner /> : <Suspense fallback={<CircularSpinner />}>{children}</Suspense>}
    </motion.div>
  );
};

export default function LandingPage() {
  return (
    <div className="min-h-screen">
      <LazyLoadSection>
        <HeroSection />
      </LazyLoadSection>
      <LazyLoadSection>
        <TravelExperience />
      </LazyLoadSection>
      <LazyLoadSection>
        <BusinessPartnerSection />
        <PrimaryTaskSection />
      </LazyLoadSection>
      <LazyLoadSection>
        <USPSection />
      </LazyLoadSection>
      <LazyLoadSection>
        <AboutSection />
      </LazyLoadSection>
      <LazyLoadSection>
        <AgentPartnerSection />
      </LazyLoadSection>
      <LazyLoadSection>
        <AllInOne />
      </LazyLoadSection>
      <LazyLoadSection>
        <BookingProcess />
      </LazyLoadSection>
      <LazyLoadSection>
        <BusinessPartner />
      </LazyLoadSection>
      <LazyLoadSection>
        <RideWithAi />
      </LazyLoadSection>
      <LazyLoadSection>
        <ManagementAgents />
      </LazyLoadSection>
      <LazyLoadSection>
        <PartnerSection />
      </LazyLoadSection>
    </div>
  );
}
